import React, { useState, useEffect } from "react";
import { Button, Form, message, Input } from 'antd';
import { Link, useNavigate } from 'react-router-dom'
import { LockOutlined, UserOutlined, SafetyOutlined } from '@ant-design/icons';
import { login } from "../../API";
import { useTranslation } from 'react-i18next';

import './login.scss'

const Login = () => {

    const navigate = useNavigate()
    const { t } = useTranslation();

    const [captchaColors, setCaptchaColors] = useState([]);

    const [code, setCode] = useState('')

    const [form] = Form.useForm();  

    function getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    }

    function generateRandomCaptcha() {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var code = '';
        var colors = [];
        for (var i = 0; i < 6; i++) {
            code += characters.charAt(Math.floor(Math.random() * characters.length));
            colors.push(getRandomColor())
        }
        setCode(code)
        setCaptchaColors(colors)
    }

    useEffect(() => {
        generateRandomCaptcha();
    }, []);

    
    const initialValues = {
        "username": '',
        "password": '',
        "verify": '',
    };


    const onFinish = (values) => {
        if (values?.verify.toLowerCase() == code.toLowerCase()) {
            login({ username: values?.username, password: values?.password }).then(res => {
                if (res?.data?.code === 200) {
                    navigate('/monitor')
                    localStorage.setItem("token", res.data.token)
                    message.success(t('login.success'))
                } else {
                    form.setFieldsValue({ password: '', verify: "" })
                    message.error(res?.data?.msg)
                }
            }).catch(err => {
                console.log(err);
            })
        } else {
            message.error(t('login.error'));
            form.setFieldsValue({ verify: "" })
        }
        generateRandomCaptcha();
    };


    return (
        <div className="login">
            <div className="left">
                <div className="car">
                    <img src={process.env.PUBLIC_URL + '/logo/car.png'} alt="" />
                </div>
            </div>
            <div className="right">
                <div className="title">
                    <div className="logo">
                        <img src={process.env.PUBLIC_URL + '/logo/logo.jpg'} alt='logo' width="54px" height='41px' />
                        {t('login.platform')}
                    </div>
                </div>
                <div className="type">{t('login.type')}</div>
                <Form
                    name="normal_login"
                    className="login-form"
                    form={form}
                    initialValues={initialValues}
                    autoComplete="off"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="username"
                        rules={[
                            {
                                required: true,
                                message: t('login.usernameRequired'),
                            },
                        ]}
                    >
                        <Input prefix={<React.Fragment><UserOutlined className="site-form-item-icon" />&nbsp;{t('login.username')}</React.Fragment>} placeholder="请输入..." />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: t('login.passwordRequired'),
                            },
                        ]}
                    >
                        <Input
                            prefix={<React.Fragment><LockOutlined className="site-form-item-icon" />&nbsp;{t('login.password')}</React.Fragment>}
                            type="password"
                            placeholder="请输入..."
                            value="admin"
                        />
                    </Form.Item>
                    <Form.Item
                        name="verify"
                        rules={[
                            {
                                required: true,
                                message: t('login.captchaRequired'),
                            },
                        ]}
                    >
                        <Input
                            prefix={<React.Fragment><SafetyOutlined className="site-form-item-icon" />&nbsp;{t('login.captcha')}</React.Fragment>}
                            addonAfter={
                                <div onClick={generateRandomCaptcha} style={{ cursor: "pointer", userSelect: "none", display: "flex", gap: "2px" }}>
                                    {String(code || '').split('').map((ch, index) => (
                                        <span key={`${ch}-${index}`} style={{ color: captchaColors[index] || getRandomColor(), fontWeight: 600 }}>
                                            {ch}
                                        </span>
                                    ))}
                                </div>
                            }
                            type="verify"
                        />
                    </Form.Item>
                    <div className="login-links">
                        <span className="login-links-left">
                            {t('login.noAccount')}
                            <Link to="/register">{t('login.registerNow')}</Link>
                        </span>
                        <Link to="/forgot">{t('login.forgotPassword')}</Link>
                    </div>
                    <Form.Item style={{ margin: "50px 0 15px 0" }}>
                        <Button style={{ width: "100%" }} type="primary" htmlType="submit" className="login-form-button subButton">
                            {t('login.loginBtn')}
                        </Button >
                    </Form.Item>
                </Form>
            </div>
            <footer>©2025昌谷（宁波）  备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备2023036666号-1</a></footer>
        </div>
    )
}

export { Login }
